import Vue from 'vue';
import { Component, Emit, Inject, Prop, Ref } from 'vue-property-decorator';
import Moment from 'moment';

import { ClassScheduleProvider } from '../class-schedule.provider';

@Component({
  name: 'ed-class-schedule-hours',
  components: {
    VueTimepicker: () => import(/* "VueTimepicker" */ 'vue2-timepicker/src/vue-timepicker.vue'),
  },
})
export default class EdClassScheduleHoursComponent extends Vue {
  @Prop({ default: false }) readonly disabled: boolean;

  @Inject()
  ScheduleProvider: ClassScheduleProvider;

  startHour = { hh: '08', mm: '00', A: 'AM', };
  endHour = { hh: '07', mm: '00', A: 'PM', };
  saving = false;
  hasServiceError = false;
  serviceErrorMessage = '';

  @Ref('sheduleHoursMenu') sheduleHoursMenu: any;

  @Emit('scheduleHoursChanged') 
  emitScheduleHoursChanged() {
    return;
  }

  get hasConflictsHours(): boolean {
    const start = this.startHour;
    const end = this.endHour;

    const startMoment = Moment(`${start.hh}:${start.mm} ${start.A}`, 'HH:mm A');
    const endMoment = Moment(`${end.hh}:${end.mm} ${end.A}`, 'HH:mm A');

    return startMoment.isAfter(endMoment) || startMoment.isSame(endMoment);
  }

  get hasHoursFilled(): boolean {
    return this.startHour.hh !== '' && this.startHour.mm !== '' && this.startHour.A !== '' &&
      this.endHour.hh !== '' && this.endHour.mm !== '' && this.endHour.A !== '';
  }

  get isFormValid(): boolean {
    return this.hasHoursFilled && !this.hasConflictsHours && !this.saving;
  }

  onFormChanged() {
    this.hasServiceError = false;
  }

  async save() {
    try {
      this.saving = true;
      await this.ScheduleProvider.saveScheduleHours(
        this.ScheduleProvider.transformFromVuePickerToString(this.startHour),
        this.ScheduleProvider.transformFromVuePickerToString(this.endHour),
      );
      this.emitScheduleHoursChanged();
      
      this.close();
    } catch(errors) {
      this.hasServiceError = true;
      this.serviceErrorMessage = errors[0].message;
    } finally {
      this.saving = false;
    }
  }

  created() {
    this.setStartEndHour();
  }

  setStartEndHour() {
    const startHour = this.ScheduleProvider.scheduleStartHour || '08:00';
    const endHour = this.ScheduleProvider.scheduleEndHour || '19:00';

    this.startHour = this.ScheduleProvider.transformFromStringToVuePicker(startHour);
    this.endHour = this.ScheduleProvider.transformFromStringToVuePicker(endHour);
  }

  close() {
    this.hasServiceError = false;
    
    this.sheduleHoursMenu.closeMenu();
  }
}